import { NgModule } from '@angular/core';

import { AccountSetupApiService } from './account-setup-api.service';

@NgModule({
  imports: [],
  providers: [AccountSetupApiService],
  exports: [],
})
export class AccountSetupSharedModule {}
